const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050/api';

async function request(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  };

  // If uploading FormData, delete Content-Type so browser sets boundary automatically
  if (options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  try {
    const response = await fetch(url, config);
    const result = await response.json();

    if (!response.ok || !result.success) {
      const baseMsg = result?.error?.message || `API Error (${response.status})`;
      // Ghép chi tiết lỗi validation để người dùng biết đúng trường nào sai
      const detailMsg = Array.isArray(result?.error?.details)
        ? result.error.details.map(d => d.message || d.field).filter(Boolean).join('; ')
        : '';
      const errorMsg = detailMsg ? `${baseMsg}: ${detailMsg}` : baseMsg;
      const error = new Error(errorMsg);
      error.status = response.status;
      error.details = result?.error?.details || null;
      error.code = result?.error?.code || 'UNKNOWN_ERROR';
      throw error;
    }

    return result.data;
  } catch (err) {
    console.error(`[API Request Error] ${options.method || 'GET'} ${url}:`, err);
    throw err;
  }
}

export const api = {
  // Health
  checkHealth: () => request('/health'),

  // Catalogs
  getCatalogs: () => request('/catalogs'),
  getVoices: () => request('/catalogs/voices'),
  getAvatars: () => request('/catalogs/avatars'),
  getBackgrounds: () => request('/catalogs/backgrounds'),
  getTemplates: () => request('/catalogs/templates'),

  // Projects
  getProjects: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return request(`/projects${query ? `?${query}` : ''}`);
  },
  getProject: (id) => request(`/projects/${id}`),
  createProject: (data) => request('/projects', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  updateProject: (id, updates) => request(`/projects/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(updates)
  }),
  // Sinh bộ pose mascot (chỉ trái / chỉ phải / giơ tay) bằng AI từ ảnh gốc
  generateAvatarPoses: (projectId) => request(`/projects/${projectId}/avatar-poses`, {
    method: 'POST'
  }),
  deleteProject: (id) => request(`/projects/${id}`, {
    method: 'DELETE'
  }),

  // Assets
  uploadProjectAsset: (projectId, file, type = 'OTHER') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    return request(`/projects/${projectId}/assets`, {
      method: 'POST',
      body: formData
    });
  },
  uploadAsset: (file, type = 'OTHER') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    return request('/assets/upload', {
      method: 'POST',
      body: formData
    });
  },
  deleteAsset: (id) => request(`/assets/${id}`, {
    method: 'DELETE'
  }),

  // AI Script & TTS
  generateScript: (projectId, options = {}) => request(`/projects/${projectId}/script/generate`, {
    method: 'POST',
    body: JSON.stringify(options)
  }),
  getScript: (projectId) => request(`/projects/${projectId}/script`),
  saveScript: (projectId, scriptData) => request(`/projects/${projectId}/script`, {
    method: 'PUT',
    body: JSON.stringify(scriptData)
  }),
  generateScriptAudio: (projectId) => request(`/projects/${projectId}/script/audio`, {
    method: 'POST'
  }),
  previewTTS: (payload) => request('/tts/preview', {
    method: 'POST',
    body: JSON.stringify(payload)
  }),

  // Render Jobs
  createRenderJob: (projectId, options = {}) => request(`/projects/${projectId}/render-jobs`, {
    method: 'POST',
    body: JSON.stringify(options)
  }),
  getRenderJob: (jobId) => request(`/render-jobs/${jobId}`),
  cancelRenderJob: (jobId) => request(`/render-jobs/${jobId}/cancel`, {
    method: 'POST'
  }),
  getProjectRenderJobs: (projectId) => request(`/projects/${projectId}/render-jobs`)
};

export default api;
